// Shared source of truth for the "Get Involved" volunteer categories.
// Keep the `key`s stable — they're used for admin filtering and CSV export.
// The backend does not enforce this schema (it accepts any string keys), so
// adding a new category here + shipping the frontend is enough.

export const CATEGORIES = [
  {
    key: "social",
    title: "Social Events & Gatherings",
    description: "Help plan or support opportunities for neighbors to connect.",
    icon: "PartyPopper",
    accent: "#C86650",
    options: [
      { key: "wine_down_wednesdays", label: "Wine Down Wednesdays" },
      { key: "singles_mixers", label: "Singles Mixers" },
      { key: "game_nights", label: "Game Nights" },
      { key: "community_cookouts", label: "Community Cookouts" },
      { key: "holiday_parties", label: "Holiday Parties" },
      { key: "family_events", label: "Family Events" },
      { key: "other_social", label: "Other Social Events" },
    ],
  },
  {
    key: "decor",
    title: "Community Décor & Celebrations",
    description: "Help make our neighborhoods festive and celebrate special moments throughout the year.",
    icon: "Sparkles",
    accent: "#B7472F",
    options: [
      { key: "holiday_decorating", label: "Holiday Decorating" },
      { key: "seasonal_decorating", label: "Seasonal Decorating" },
      { key: "graduation_celebrations", label: "Graduation Celebrations" },
      { key: "special_event_decor", label: "Special Event Décor" },
      { key: "decor_setup_takedown", label: "Decorating Setup & Takedown" },
    ],
  },
  {
    key: "wellness",
    title: "Fitness, Wellness & Recreation",
    description: "Help organize or lead activities that get neighbors moving and spending time together.",
    icon: "Heart",
    accent: "#2C4C3B",
    options: [
      { key: "yoga", label: "Yoga" },
      { key: "line_dancing", label: "Line Dancing" },
      { key: "walking_groups", label: "Walking Groups" },
      { key: "fitness_classes", label: "Fitness Classes" },
      { key: "sports_rec", label: "Sports & Recreation" },
      { key: "wellness_activities", label: "Wellness Activities" },
      { key: "teach_lead_activity", label: "I'm Interested in Teaching or Leading an Activity" },
    ],
  },
  {
    key: "family",
    title: "Family, Youth & Senior Activities",
    description: "Help create activities and experiences for residents of all ages.",
    icon: "Users",
    accent: "#8A5A2B",
    options: [
      { key: "kids_family_activities", label: "Kids & Family Activities" },
      { key: "teen_activities", label: "Teen Activities" },
      { key: "senior_activities", label: "Senior Activities" },
      { key: "back_to_school", label: "Back-to-School Events" },
      { key: "graduation_activities", label: "Graduation Activities" },
      { key: "family_game_movie_nights", label: "Family Game or Movie Nights" },
    ],
  },
  {
    key: "volunteer_team",
    title: "Community Volunteer Team",
    description: "Want to help but don't have one specific interest? Join our general volunteer list and lend a hand when opportunities arise.",
    icon: "HandHeart",
    accent: "#5C6A64",
    options: [
      { key: "community_cleanups", label: "Community Cleanups" },
      { key: "event_setup_cleanup", label: "Event Setup & Cleanup" },
      { key: "welcome_new_neighbors", label: "Welcome New Neighbors" },
      { key: "community_improvement", label: "Community Improvement Projects" },
      { key: "general_event_support", label: "General Event Support" },
      { key: "wherever_needed", label: "Wherever Help Is Needed" },
    ],
  },
];

// "How Would You Like to Participate?" — cross-category role preferences.
export const PARTICIPATION_ROLES = [
  { key: "plan", label: "Help plan activities" },
  { key: "volunteer", label: "Volunteer at activities" },
  { key: "lead", label: "Lead or teach an activity" },
  { key: "setup_decorate", label: "Help with setup or decorating" },
  { key: "behind_scenes", label: "Help behind the scenes" },
  { key: "wherever", label: "I'm open to helping wherever needed" },
];

export const NEIGHBORHOODS = ["Saddleridge", "Savoy Chase", "The Trails"];

// Flat lookup { optionKey → label } for admin rendering.
export const OPTION_LABEL_BY_KEY = CATEGORIES.reduce((acc, cat) => {
  cat.options.forEach((o) => { acc[o.key] = o.label; });
  return acc;
}, {});
export const CATEGORY_LABEL_BY_KEY = CATEGORIES.reduce((acc, c) => {
  acc[c.key] = c.title;
  return acc;
}, {});
export const PARTICIPATION_LABEL_BY_KEY = PARTICIPATION_ROLES.reduce((acc, r) => {
  acc[r.key] = r.label;
  return acc;
}, {});
